class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;
        self.navToggle = self.elem.querySelector('[data-nav-toggle]');
        self.nav = self.elem.querySelector('[data-nav]');
        self.navPanel = self.nav ? self.nav.querySelector('.nav__panel') : null;
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;

        if (!self.nav || !self.navToggle) return;

        self.navToggle.addEventListener('click', evt => {
            evt.preventDefault();
            evt.stopPropagation();

            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });
    }

    open() {
        let self = this;
        
        // Add is-active class to hamburger
        self.navToggle.classList.add('is-active');

        // Set aria-expanded attribute to true
        self.navToggle.setAttribute('aria-expanded', true);

        // Activate the nav
        self.nav.classList.add('is-active');
        self.nav.setAttribute('aria-hidden', 'false');
        
        // Force a re-paint
        let reflow = self.nav.offsetHeight;

        // Open the nav
        self.nav.classList.add('is-visible');

        // Toggle scrolling on body
        self.body.classList.add('is-no-scroll');
        
        // Add event listeners
        self.addEventListeners();

        self.isOpen = true;
    }

    close() {
        let self = this;

        // Remove is-open class from nav
        self.nav.classList.remove('is-visible');

        // Toggle scrolling on body
        self.body.classList.remove('is-no-scroll');

        // Function to remove is-active class from nav element once transition is complete
        let func = function() {
            // Remove is-active class from hamburger
            self.navToggle.classList.remove('is-active');

            // Set aria-expanded attribute to false
            self.navToggle.setAttribute('aria-expanded', false);

            // Remove is-open and is-active classes from nav
            self.nav.classList.remove('is-active');
            self.nav.setAttribute('aria-hidden', 'true');
            
            // Remove event listeners
            self.removeEventListeners();

            self.isOpen = false;

            self.nav.removeEventListener('transitionend', func);
        }

        self.nav.addEventListener('transitionend', func, false);
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the nav
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the nav
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // The .nav element covers the full viewport, so we test against
        // the inner panel to detect clicks outside the visible menu.
        const inPanel = self.navPanel && (evt.target === self.navPanel || self.navPanel.contains(evt.target));
        const inToggle = evt.target === self.navToggle || self.navToggle.contains(evt.target);

        if (!inPanel && !inToggle) {
            self.close();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }
}

export default Nav;
